module.exports = __webpack_public_path__ + "img/espol.d7cd3621.png";